import { categoryService } from "@/services/category-service";
import { CategoryDto } from "@/types/dto/category-dto";
import { Select } from "flowbite-react";
import { useEffect, useState } from "react";

interface Props {
  defaultCategoryId?: number;
  updateCategoryId: (categoryId: number) => void;
}

export const ItemCategoryDropdown: React.FC<Props> = ({
  defaultCategoryId,
  updateCategoryId,
}) => {
  const [categories, setCategories] = useState<CategoryDto[]>([]);

  const getCategoryAll = async () => {
    try {
      const response = await categoryService.getAll(false);
      if (!response.ok) {
        return;
      }
      setCategories([...response.data]);
      // setCategories(response); // TODO 리스트로 담겨와야됨
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    getCategoryAll();
  }, []);

  return (
    <Select
      className="w-[328px]"
      onChange={(e) => updateCategoryId(Number(e.target.value))}
      // defaultValue={defaultCategoryId}
      value={defaultCategoryId}
    >
      <option key={0} value={0}>
        카테고리를 선택해주세요.
      </option>
      {categories.map((category) => (
        <option key={category.id} value={category.id}>
          {category.name}
        </option>
      ))}
    </Select>
  );
};
